import React, { useEffect, useRef } from "react";
import "./MathModulePage.css";

const MathModulePage = ({ path }) => {
  const iframeRef = useRef(null);

  const updateIframeHeight = () => {
    if (iframeRef.current) {
      const iframeDocument =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;
      iframeRef.current.style.height = `${iframeDocument.body.scrollHeight}px`;
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    iframe.addEventListener("load", updateIframeHeight);

    return () => {
      iframe.removeEventListener("load", updateIframeHeight);
    };
  }, []);
  return (
    <iframe
      ref={iframeRef}
      className="math_ifr"
      src={path}
      style={{ border: "none" }}
      title="Mathematics"
    ></iframe>
  );
};

export default MathModulePage;
